import type { ApiCommunications, NullPromise } from '../../webmodule-common/interop/webmodule-interop';
import type {
  FabricationJobState,
  InputAddQuoteItemToFabricationJob,
  InputCleanupQuoteFabricationData,
  InputCreateFabricationJob,
  InputCreateQuoteItemFabrications,
  InputDeleteFabricationJob,
  InputRemoveQuoteItemFromFabricationJob,
  InputUpdateFabricationJob,
  InputUpdateFabricationJobItemUnitOverrides,
  RequestGetFabricationJob,
  RequestGetFabricationJobSummary,
  RequestGetFabricationJobTotalsByState,
  RequestGetQuoteItemFabricationStatuses,
  ResultCleanupQuoteFabricationData,
  ResultCreateFabricationJob,
  ResultCreateQuoteItemFabrications,
  ResultGetFabricationJob,
  ResultGetFabricationJobTotalsByState,
  ResultGetQuoteItemFabricationStatuses,
  ResultUpdateFabricationJob,
  FabricationJobSummaryViewResultPaginated
} from './dealer-api-interface-all';

export { FabricationJobState, QuoteItemFabricationStatus } from './dealer-api-interface-all';

export type {
  FabricationJob,
  FabricationJobItem,
  FabricationJobStateCount,
  FabricationJobSummaryView,
  InputUnitOverride,
  QuoteItemFabricationStatusView,
  UnitOptionOverride
} from './dealer-api-interface-all';

/**
 * Content type identifier for Fabricated Standard Frames (V6 CID_FRAM).
 * Used by the approval flow to filter eligible quote items.
 */
export const fabricatedStandardFrameContentType = 7;

// SSE event interfaces
export interface SSEFabricationJob {
  id: string;
  recordVersion: string;
  state: FabricationJobState;
  lastModifiedUserId: string;
}

export interface SSEQuoteFabricationStatus {
  quoteItemIds: string[];
}

export interface SSEBranchQuoteFabricationLock {
  quoteId: string;
  lockForFabrication: boolean;
}

export interface FabricationJobApi {
  api: ApiCommunications;

  getFabricationJob: (request: RequestGetFabricationJob) => NullPromise<ResultGetFabricationJob>;
  getFabricationJobSummary: (
    request: RequestGetFabricationJobSummary
  ) => NullPromise<FabricationJobSummaryViewResultPaginated>;
  getFabricationJobTotalsByState: (
    request: RequestGetFabricationJobTotalsByState
  ) => NullPromise<ResultGetFabricationJobTotalsByState>;
  getQuoteItemFabricationStatuses: (
    request: RequestGetQuoteItemFabricationStatuses
  ) => NullPromise<ResultGetQuoteItemFabricationStatuses>;

  createFabricationJob: (input: InputCreateFabricationJob) => NullPromise<ResultCreateFabricationJob>;
  updateFabricationJob: (input: InputUpdateFabricationJob) => NullPromise<ResultUpdateFabricationJob>;
  deleteFabricationJob: (input: InputDeleteFabricationJob) => NullPromise<ResultUpdateFabricationJob>;

  addQuoteItemToFabricationJob: (input: InputAddQuoteItemToFabricationJob) => NullPromise<ResultUpdateFabricationJob>;
  removeQuoteItemFromFabricationJob: (
    input: InputRemoveQuoteItemFromFabricationJob
  ) => NullPromise<ResultUpdateFabricationJob>;
  updateFabricationJobItemUnitOverrides: (
    input: InputUpdateFabricationJobItemUnitOverrides
  ) => NullPromise<ResultUpdateFabricationJob>;

  createQuoteItemFabrications: (
    input: InputCreateQuoteItemFabrications
  ) => NullPromise<ResultCreateQuoteItemFabrications>;
  cleanupQuoteFabricationData: (
    input: InputCleanupQuoteFabricationData
  ) => NullPromise<ResultCleanupQuoteFabricationData>;
}
